export default __webpack_public_path__ + "static/media/Tunic of the Sepulcher.1bc26366.jpg";